import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openWhatsApp = () => {
    window.open('https://wa.me/60126759467?text=Hello%20EWRF,%20I%20would%20like%20to%20know%20more%20about%20your%20programmes.', '_blank');
  };

  return (
    <button
      onClick={openWhatsApp}
      className={`fixed bottom-44 md:bottom-52 right-4 md:right-8 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] rounded-full shadow-2xl flex items-center justify-center text-white font-semibold transition-all duration-300 hover:scale-110 z-50 group ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20 pointer-events-none'
      }`}
      aria-label="Contact us on WhatsApp"
    >
      <div className="text-center relative">
        <MessageCircle className="w-7 h-7 md:w-8 md:h-8 fill-white" />
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
      </div>
      <div className="absolute right-full mr-3 bg-[#25D366] text-white px-3 py-2 rounded-lg text-xs md:text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
        Chat with us on WhatsApp
        <div className="absolute left-full top-1/2 -translate-y-1/2 border-8 border-transparent border-l-[#25D366]"></div>
      </div>
    </button>
  );
};

export default FloatingWhatsApp;
